import { Navigate, Outlet } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "../auth/AuthContext.js";

export function CustomerRoute() {
  const auth = useAuth();
  if (auth.status === "loading") {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }
  if (auth.status !== "authenticated") {
    return <Navigate to="/login" replace />;
  }
  if (auth.session?.role === "admin") {
    return <Navigate to="/admin" replace />;
  }
  if (auth.session?.role !== "customer") {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
